import { useSnackbar } from "notistack";
import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  add_feed_comment,
  delete_comment_api,
  edit_feed_comment,
} from "src/DAL/Community/Comments";
import SingleComment from "./SingleComment";
import CommentComposer from "./CommentComposer";
import { get_feeds_detail } from "src/DAL/Community/Community";
import CustomConfirmation from "src/components/GeneralComponents/CustomConfirmation";
import { s3baseUrl } from "src/config/config";
import GrButton from "src/design-system/components/GrButton";

function FeedComments(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { feed_id, is_popup, getFeedsListingOnAddFeed, getFeedsDeteil } =
    props;
  const [feedDetailComments, setFeedDetailComments] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const [formAction, setFormAction] = useState("ADD");
  const [commentInput, setCommentInput] = useState("");
  const [selectedComment, setSelectedComment] = useState({});
  const [isLoadingForm, setIsLoadingForm] = useState(false);
  const observer = useRef();
  const [image, setImage] = React.useState("");
  const [previews, setPreviews] = useState("");
  const [oldImage, setOldImage] = useState("");
  const handleRemove = () => {
    setPreviews("");
    setOldImage("");
    setImage("");
  };
  const handlePickImage = (file) => {
    setImage(file);
    setPreviews(URL.createObjectURL(file));
  };
  const lastBookElementRef = useCallback(
    (node) => {
      if (isLoadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && totalPages > pageNumber) {
          loadMoreData();
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoadingMore, totalPages, pageNumber, observer]
  );

  const handleCommentEdit = (selected_comment) => {
    setSelectedComment(selected_comment);
    setCommentInput(selected_comment.text);
    if (selected_comment.comment_image?.thumbnail_1) {
      setOldImage(selected_comment.comment_image?.thumbnail_1);
    }
    setFormAction("EDIT");
  };

  const handleCommentDelete = (selected_comment) => {
    setOpenDelete(true);
    setSelectedComment(selected_comment);
  };

  const handleDelete = async () => {
    setOpenDelete(false);
    const result = await delete_comment_api(selectedComment._id);
    if (result.code === 200) {
      getFeedsComments("all");
      getFeedsDeteil();
      getFeedsListingOnAddFeed(feed_id);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleCancelUpdate = (e) => {
    e.preventDefault();
    setCommentInput("");
    handleRemove();
    setFormAction("ADD");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("feed", feed_id);
    formData.append("text", commentInput);
    if (image) {
      formData.append("comment_image", image);
    }
    if (commentInput == "" && !image) {
      enqueueSnackbar("At least  add Text or an Image in Comment", {
        variant: "error",
      });
    } else {
      setIsLoadingForm(true);
      const result = await add_feed_comment(formData);
      if (result.code === 200) {
        getFeedsComments("all");
        setCommentInput("");
        getFeedsDeteil();
        handleRemove();
        setIsLoadingForm(false);
        getFeedsListingOnAddFeed(feed_id);
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
        setIsLoadingForm(false);
      }
    }
  };
  const handleUpdate = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("text", commentInput);
    if (oldImage || image) {
      if (image) {
        formData.append("comment_image", image);
        formData.append("is_cancelled", false);
      } else if (selectedComment.comment_image?.thumbnail_1) {
        formData.append("is_cancelled", false);
      }
    } else {
      formData.append("is_cancelled", true);
    }
    if (commentInput == "" && !image && !oldImage) {
      enqueueSnackbar("At least  add Text or an Image in Comment", {
        variant: "error",
      });
    } else {
      setIsLoadingForm(true);
      const result = await edit_feed_comment(formData, selectedComment._id);
      if (result.code === 200) {
        getFeedsComments("all");
        setCommentInput("");
        setCommentInput("");
        handleRemove();
        setIsLoadingForm(false);
        setFormAction("ADD");
        getFeedsListingOnAddFeed(feed_id);
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
        setIsLoadingForm(false);
      }
    }
  };

  const getFeedsComments = async () => {
    const result = await get_feeds_detail(feed_id);
    if (result.code === 200) {
      setFeedDetailComments(result.feed.comments);
      setIsLoadingMore(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoadingMore(false);
    }
  };
  const loadMoreData = () => {
    getFeedsComments("next");
  };

  useEffect(() => {
    getFeedsComments("all");
  }, [feed_id]);

  return (
    <>
      <div className="profile-comments profile-main-comments">
        {feedDetailComments.length > 0 &&
          feedDetailComments.map((comment) => {
            return (
              <SingleComment
                key={comment._id}
                comment={comment}
                is_popup={is_popup}
                handleCommentEdit={handleCommentEdit}
                handleCommentDelete={handleCommentDelete}
                openDetailModal={true}
                handleUpdateSpecificFeed={() => {
                  getFeedsComments("all");
                }}
              />
            );
          })}
        {totalPages > pageNumber ? (
          <div className="view-comment">
            {isLoadingMore ? (
              <GrButton variant="link" size="sm" onClick={loadMoreData}>
                Loading...
              </GrButton>
            ) : (
              <GrButton
                variant="link"
                size="sm"
                ref={lastBookElementRef}
                onClick={loadMoreData}
                id="load-more-comments"
              >
                View more comments
              </GrButton>
            )}
          </div>
        ) : (
          ""
        )}
      </div>
      <CommentComposer
        value={commentInput}
        setValue={setCommentInput}
        onSubmit={formAction === "ADD" ? handleSubmit : handleUpdate}
        loading={isLoadingForm}
        editing={formAction === "EDIT"}
        onCancel={handleCancelUpdate}
        imageSrc={previews || (oldImage ? s3baseUrl + oldImage : "")}
        onPickImage={handlePickImage}
        onRemoveImage={handleRemove}
      />
      <CustomConfirmation
        open={openDelete}
        setOpen={setOpenDelete}
        title={"Are you sure you want to delete this comment?"}
        handleAgree={handleDelete}
      />
    </>
  );
}

export default FeedComments;
